// extracted by mini-css-extract-plugin
export var logoBox = "logo-module--logo-box--KWP9Z";
export var logoDesktop = "logo-module--logo-desktop--JM7bS";
export var logoMobile = "logo-module--logo-mobile--qpnTf";